// extracted by mini-css-extract-plugin
export default {"control":"control_control__AQGUV","button":"control_button__q5P2N"};